import { createSlice } from '@reduxjs/toolkit';

const initialState = { byId: {} };

const schemaSlice = createSlice({
  name: 'schemas',
  initialState,
  reducers: {
    storeSchema(state, action) {
      if (state.byId.id) {
        // Already stored, do nothing for now.
        return;
      }
      const { payload = {} } = action;
      const { id = '', schema = {} } = payload;
      state.byId[id] = schema;
    },

    fetchSchema(state, action) {
      const { id = '' } = action;
      return state.byId[id];
    },
  },
});

export const { storeSchema, fetchSchema } = schemaSlice.actions;
export default schemaSlice.reducer;

export const saveSchema = action => dispatch => {
  if (!action.id) {
    throw new Error('An ID is required to save the schema.');
  }
  dispatch(storeSchema(action));
};
